const NOT_FOUND_COOKIE = 'NOT_FOUND'

export { NOT_FOUND_COOKIE }
